import { useEffect, useState } from 'react';
import { getLogTail } from '../api';

// jobs.log lines start with `[2026-05-09T08:30:20.716Z]` ISO 8601 (UTC, `Z` suffix)
// — too wide AND in UTC, which doesn't match the operator's wall clock.
// Rewrite to `[HH:mm DD/MM]` in the browser's LOCAL timezone for at-a-glance
// scanning. Lines without an ISO prefix are left untouched. We don't touch the
// rest of the line — the message body may legitimately contain other ISO-like
// substrings (e.g. timestamps inside JSON payloads).
const ISO_TS = /\[(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d+Z)\]/g;
const pad = (n: number) => String(n).padStart(2, '0');
function shortenTimestamps(text: string): string {
  return text.replace(ISO_TS, (_full, iso) => {
    const dt = new Date(iso);
    if (Number.isNaN(dt.getTime())) return _full; // unparseable — leave as-is
    return `[${pad(dt.getHours())}:${pad(dt.getMinutes())} ${pad(dt.getDate())}/${pad(dt.getMonth() + 1)}]`;
  });
}

export function LogTail() {
  const [lines, setLines] = useState<string>('(loading)');
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    let live = true;
    async function tick() {
      try {
        const t = await getLogTail(80);
        if (!live) return;
        setLines(shortenTimestamps(t));
        setErr(null);
      } catch (e) {
        if (!live) return;
        setErr(e instanceof Error ? e.message : String(e));
      }
    }
    tick();
    const id = setInterval(tick, 10_000);
    return () => { live = false; clearInterval(id); };
  }, []);

  return (
    <div className="card log-card">
      <h3>jobs.log (tail)</h3>
      {err && <p className="errors">{err}</p>}
      <pre className="log-tail">{lines}</pre>
    </div>
  );
}
